import { ReactNode } from 'react';
import styled from 'styled-components';

export interface HeroProps {
  children: ReactNode;
  className?: string;
  backgroundUrl?: string;
  backgroundAltText?: string;
  backgroundSrcSet?: string;
  backgroundSizes?: string;
}

const StyledHero = styled.section`
  display: flex;
  justify-content: center;
  align-items: stretch;
  position: relative;
  min-height: 11.25rem;
`;

const BackgroundImg = styled.img`
  position: absolute;
  z-index: -1;
  object-fit: cover;
  height: 100%;
  width: 100%;
  border-radius: 0.5rem;
`;

export const Hero = ({
  backgroundUrl,
  backgroundAltText,
  backgroundSrcSet,
  backgroundSizes,
  children,
  ...rest
}: HeroProps) => (
  <StyledHero {...rest}>
    {backgroundUrl && (
      <BackgroundImg
        src={backgroundUrl}
        alt={backgroundAltText || undefined}
        srcSet={backgroundSrcSet || undefined}
        sizes={backgroundSizes || undefined}
      />
    )}
    {children}
  </StyledHero>
);

export default Hero;
